module.exports = __webpack_public_path__ + "static/media/LOADER_09.1fcc390f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_09.png
// module id = 317
// module chunks = 0